import moment from "moment";

import { MonitorTableAnalysisItem } from "../../types/analysis";

import styles from "./monitor-summary-card.module.css";

type Props = {
  tableData: MonitorTableAnalysisItem[];
};

export const MonitorSummaryCard = ({ tableData }: Props) => {
  return (
    <div className={styles.cardList}>
      {tableData.map((row, index) => (
        <div key={index} className={styles.card}>
          <div className={styles.row}>
            <span className={styles.date}>
              {moment(row.date).format("DD.MM.YYYY")}
            </span>
            <span className={styles.type}>
              {row.type === "monitoring"
                ? "Monitoring"
                : row.type === "auftrag"
                  ? "Bekämpfung"
                  : row.type}
            </span>
          </div>

          <div
            className={styles.row}
            style={{
              padding: "4px 0 8px 0",
              justifyContent: "start",
              gap: "35px",
            }}
          >
            <div className={styles.column}>
              <span className={styles.label}>Befall</span>
              <span className={styles.value}>{row.infestation.count}</span>
              <span
                className={styles.percentage}
                style={{
                  color: "#3D5170",
                  fontWeight: "500",
                }}
              >
                {row.infestation.percentage}%
              </span>
            </div>

            <div className={styles.column}>
              <span className={styles.label}>Kein Befall</span>
              <span className={styles.value}>{row.noInfestation.count}</span>
              <span
                className={styles.percentage}
                style={{
                  color: "#3D5170",
                  fontWeight: "500",
                }}
              >
                {row.noInfestation.percentage}%
              </span>
            </div>

            <div className={styles.column}>
              <span className={styles.label}>Gesamt</span>
              <span className={styles.value}>{row.monitorsTotal}</span>
              <span
                className={styles.percentage}
                style={{
                  color: "#11A8B8",
                }}
              >
                geprüft: {row.monitorsChecked}
              </span>
            </div>
          </div>

          {row.unreachable.count > 0 && (
            <div
              className={styles.row}
              style={{ borderTop: "0.5px solid #F2F2F2" }}
            >
              <span className={styles.percentage} style={{ paddingTop: "4px" }}>
                Nicht erreichbar:{" "}
                <span className={styles.orange}>{row.unreachable.count}</span>
              </span>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};
